import { render, staticRenderFns } from "./RiskSort.vue?vue&type=template&id=4f1e0676&scoped=true&"
import script from "./RiskSort.vue?vue&type=script&lang=js&"
export * from "./RiskSort.vue?vue&type=script&lang=js&"
import style0 from "./RiskSort.vue?vue&type=style&index=0&id=4f1e0676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1e0676",
  null
  
)

export default component.exports